import { useBranding } from '@/lib/branding';

// Display-layer branding for the Template Library. The machine pack_id (e.g. triniticare-core) is never changed here;
// it stays in API payloads, origin_ref provenance, checksums and audit events. Only what the user reads is branded.
const FALLBACK_LIBRARY = 'Form Library';
const FALLBACK_PUBLISHER = 'Platform';
const SOURCE_FORM_REF = /^TC-FORM-(\d+)$/i;

export function libraryDisplay(organisationName) {
  const org = typeof organisationName === 'string' ? organisationName.trim() : '';
  const libraryName = org ? `${org} ${FALLBACK_LIBRARY}` : FALLBACK_LIBRARY;
  return {
    libraryName,
    publisher: org || FALLBACK_PUBLISHER,
    packLabel: (version) => (version ? `${libraryName} · v${version}` : libraryName),
  };
}

export function useLibraryBranding() {
  const { organisationName } = useBranding() || {};
  return libraryDisplay(organisationName);
}

// Neutral wording for vendor source-form references: never re-attributes the source to the current organisation.
export function sourceRefLabel(ref) {
  if (!ref) return '';
  const m = SOURCE_FORM_REF.exec(String(ref.ref || ''));
  if (m) return `Source form ${m[1]} — structure reference only.`;
  return ref.label || ref.ref || '';
}
